// 订单清单专用显示元数据；不更改记录、业务插槽、筛选和操作事件。
import type { AdaptiveColumn } from './responsiveTable'
// 仅表格内容超出可用宽度时等比缩放；保留全部列和完整按钮，不改变业务数据。
export function orderTableScale(contentWidth:number,availableWidth:number):number {
 if(!Number.isFinite(contentWidth) || !Number.isFinite(availableWidth) || contentWidth<=0 || availableWidth<=0 || contentWidth<=availableWidth)return 1
 return Math.floor(availableWidth/contentWidth*1000000)/1000000
}
export const orderField=(column:AdaptiveColumn)=>Array.isArray(column.dataIndex)?column.dataIndex.join('.'):String(column.dataIndex || column.key || '')
export function orderCellClass(column:AdaptiveColumn):string {
 const key=orderField(column)
 if(/^(commands?|subcommand|operate|operations?|actions?|refound|delete|view)$/i.test(key))return 'order-fit-action'
 if(/^(levelExpired|lastLogin)$/.test(key) || /(time|date|expiredAt|createdAt|updatedAt)$/i.test(key))return 'order-fit-time'
 if(/^(mounted|downShared|shared|pinnedAt)$/.test(key) || /(price|amount|balance|fee|money|total|status|state)$/i.test(key))return 'order-fit-critical'
 return 'order-fit-flex'
}
export function orderFitColumns<T extends AdaptiveColumn>(columns:T[],rows:any[],measured:Record<string,number>={}):T[] {
 const productList=columns.some(column=>orderField(column)==='pinnedAt')
 const customerList=columns.some(column=>orderField(column)==='displayLevel')
 return columns.filter(column=>{
  // 只去除记录明确没有评分的列；下载等业务插槽不能根据缺少同名字段误删。
  if(!['score','rating'].includes(orderField(column)) || !rows.length)return true
  return rows.some(row=>Number(row[orderField(column)])>0)
 }).map(column=>{
  if(column.children?.length)return {...column,children:orderFitColumns(column.children,rows)} as T
  const key=orderField(column),kind=orderCellClass(column)
  const explicit=Number(column.width)||0
  let preferred=92,floor=26,flex=1,maximum:number|undefined
  const compactProductWidths:Record<string,number>={boke:42,sizeCount:38,pltCount:32,bingdingCount:38,pltPrice:68}
  const productType=key==='costPrice' && ((column as any).slots?.customRender==='类型' || column.title==='类型')
  if(kind==='order-fit-action')return {...column,orderFit:true,fitFloor:Number(column.minWidth)||explicit||80,className:[(column as any).className,kind].filter(Boolean).join(' ')} as T
  if(productType){preferred=120;floor=120;maximum=120;flex=0}
  else if(productList && key==='status'){preferred=52;floor=50;maximum=52;flex=0}
  else if(productList && key==='lastUpdateOperatorName'){preferred=72;floor=62;maximum=72;flex=0}
  else if(customerList && /^(days|leftCount|limit|blocked|sourceFrom)$/.test(key)){preferred=({days:34,leftCount:38,limit:38,blocked:48,sourceFrom:46} as Record<string,number>)[key];floor=preferred;maximum=preferred;flex=0}
  else if(customerList && key==='memo'){preferred=110;floor=110;maximum=110;flex=0}
  else if(customerList && key==='cellphone'){preferred=96;floor=96;maximum=96;flex=0}
  else if(customerList && key==='accountAmount'){preferred=68;floor=68;maximum=68;flex=0}
  else if(customerList && key==='levelExpired'){preferred=122;floor=122;maximum=122;flex=0}
  else if(compactProductWidths[key]){preferred=compactProductWidths[key];floor=preferred;maximum=preferred;flex=0}
  else if(key==='pinnedAt'){preferred=46;floor=46;flex=0}
  else if(key==='groupId'){preferred=10;floor=10;flex=0}
  else if(/^(mounted|downShared|shared)$/.test(key)){preferred=64;floor=58;flex=0}
  else if(key==='mountingTime'){preferred=122;floor=122;maximum=122;flex=0}
  else if(kind==='order-fit-time'){preferred=132;floor=122;flex=0}
  else if(kind==='order-fit-critical'){preferred=/(status|state)$/i.test(key)?86:82;floor=/(status|state)$/i.test(key)?74:74;flex=0}
  else if(/^(orderNumber|orderId|requestNumber|demandNumber)$/i.test(key)){preferred=88;floor=82;flex=0}
  else if(/(image|picture|thumbnail|img)/i.test(key)){preferred=40;floor=34;flex=0}
  else if(/^(download|attachment|attachments)$/i.test(key)){preferred=36;floor=30;flex=0}
  else if(/(phone|mobile|tel)/i.test(key)){preferred=108;floor=34}
  else if(key==='customerMemo'){preferred=110;floor=80;flex=2}
  else if(/(title|productName|description|remark|content|orderInfo)/i.test(key)){preferred=150;floor=32;flex=3}
  else if(/(name|code|number|No)$/i.test(key)){preferred=100;floor=28}
  else if(/(count|quantity|sales|rate|size|type|source)/i.test(key)){preferred=66;floor=24}
  if(kind==='order-fit-critical' || kind==='order-fit-time'){floor=Math.max(floor,measured[key] || 0);preferred=Math.max(preferred,floor)}
  if(maximum!==undefined)maximum=Math.max(maximum,floor)
  const cell=(column as any).customCell
  return {...column,customCell:(record:any,index:number)=>({...cell?.(record,index),'data-order-fit-key':key}),fixed:undefined,minWidth:preferred,maxWidth:maximum,flex,orderFit:true,fitFloor:floor,
    className:[(column as any).className,kind].filter(Boolean).join(' ')} as T
 })
}
